// extracted by mini-css-extract-plugin
export var block = "BasicText-module--block--6fd4b";